import { useTranslation } from 'react-i18next'

import { Callout } from '../Typography/Callout'

import './AppStatusBadge.scss'

type CustomMessageProps = {
  en: string
  de: string
  fr: string
  displayCustomMessage: boolean
}

/**
 * @private This component is only to use in the AppStatusBadge component
 */
export const CustomMessage = ({ de, en, fr, displayCustomMessage }: CustomMessageProps) => {
  const { i18n } = useTranslation()
  const currentLanguage = (i18n.language || 'en').split('-')[0]
  const correspondingMessage =
    {
      en: en,
      de: de,
      fr: fr,
    }[currentLanguage] ?? en

  if (!displayCustomMessage || !correspondingMessage || correspondingMessage === '') {
    return null
  }

  return (
    <Callout className="text-current" variant="callout1">
      {correspondingMessage}
    </Callout>
  )
}
